goog.provide('el8.uiwidget.CollapsibleCuratedList');

goog.require('el8.model.base');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.CuratedList');


/**
 * A CuratedList that also has a Collapsible linked to it;
 * i.e., each list item has an expandable/collapsible section. The whole
 * item, including its Collapsible, will be replaced by the inline form.
 *
 * See settings/templates.js for an example usage and CuratedList.js
 * for more explanation on what CuratedLists are good for.
 */
el8.uiwidget.CollapsibleCuratedList = function(opts) {
    this._expandFn = opts.expandFn || null;
    this._collapseFn = opts.collapseFn || null;

    el8.uiwidget.CuratedList.prototype.constructor.call(this, opts);
};
el8.uiwidget.CollapsibleCuratedList.inheritsFrom(el8.uiwidget.CuratedList);


el8.uiwidget.CollapsibleCuratedList.prototype._renderList = function(highlightId) {

    var that = this;
    el8.uiwidget.CuratedList.prototype._renderList.apply(this, arguments);

    $(this._liSelector, this._listContainer).each(function() {
        var $li = $(this);
        el8.uiwidget.collapsible({
            container: $('.collapsible-section', $li),
            triggerElt: $('.expand-collapse-trigger', $li),
            statusElt: $('.collapsible-status', $li),
            isCollapsed: true,
            expandFn: function() {
                if (that._expandFn) { that._expandFn($li); }
            },
            collapseFn: function() {
                if (that._collapseFn) { that._collapseFn($li); }
            }
        });
    });
};
